import script from "./OnBoarding.vue?vue&type=script&setup=true&lang=ts"
export * from "./OnBoarding.vue?vue&type=script&setup=true&lang=ts"

import "./OnBoarding.vue?vue&type=style&index=0&id=242f6cd1&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-242f6cd1"]])

export default __exports__